import { render, staticRenderFns } from "./LabelConfig.vue?vue&type=template&id=8db8e3fc&scoped=true&"
import script from "./LabelConfig.vue?vue&type=script&lang=js&"
export * from "./LabelConfig.vue?vue&type=script&lang=js&"
import style0 from "./LabelConfig.vue?vue&type=style&index=0&id=8db8e3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db8e3fc",
  null
  
)

export default component.exports